import { SalesChannelCreatePage } from '@/features/sales-channel/pages/SalesChannelCreatePage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/sales-channel/create')({
  component: SalesChannelCreatePage,
})
